import { useRef, useMemo } from "react";
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
import { VisibleCanvas } from "./VisibleCanvas";

function Dust({ count = 320, color = "#ffffff", size = 0.02, spread = [11, 6, 6], speed = 0.02, opacity = 0.7 }) {
  const ref = useRef();
  const positions = useMemo(() => {
    const a = new Float32Array(count * 3);
    for (let i = 0; i < count; i++) {
      a[i * 3] = (Math.random() - 0.5) * spread[0];
      a[i * 3 + 1] = (Math.random() - 0.5) * spread[1];
      a[i * 3 + 2] = (Math.random() - 0.5) * spread[2];
    }
    return a;
  }, [count, spread]);

  useFrame((state, dt) => {
    const g = ref.current;
    if (!g) return;
    g.rotation.y += dt * speed;
    const p = state.pointer;
    g.rotation.x = THREE.MathUtils.lerp(g.rotation.x, p.y * 0.12, 0.04);
    g.position.x = THREE.MathUtils.lerp(g.position.x, p.x * 0.5, 0.04);
  });

  return (
    <points ref={ref}>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" args={[positions, 3]} />
      </bufferGeometry>
      <pointsMaterial transparent color={color} size={size} sizeAttenuation depthWrite={false} opacity={opacity} blending={THREE.AdditiveBlending} />
    </points>
  );
}

// Transparent WebGL layer of floating light/dust motes that sits over the DOM hero video.
export function HeroParticles() {
  return (
    <VisibleCanvas
      className="absolute inset-0 pointer-events-none"
      camera={{ position: [0, 0, 5], fov: 55 }}
      dpr={[1, 1.6]}
    >
      <Dust count={300} color="#ffffff" size={0.018} opacity={0.55} speed={0.015} />
      <Dust count={140} color="#62B848" size={0.05} opacity={0.5} speed={0.03} spread={[10, 5, 4]} />
      <Dust count={60} color="#bff0a8" size={0.09} opacity={0.35} speed={0.045} spread={[9, 4.5, 3]} />
    </VisibleCanvas>
  );
}
